import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import ComingSoonPage from "../components/ComingSoonPage";

export default function ReportsPage() {
  return (
    <ComingSoonPage
      title="Reports Coming Soon"
      message="This feature is currently under development and will be available in a future release."
      icon={<BarChartOutlinedIcon sx={{ fontSize: 32, color: "#005BF0" }} />}
    />
  );
}
